import { accessRole } from "../../../../../helpers/access_role"
import { config } from "../../../../../helpers/config_global"
import React, { useState, Component, Fragment } from "react"
import { Redirect } from "react-router-dom"

import { Tooltip } from "reactstrap"

import MKIDatatable from '../../../../../modules/mki-datatable/lib'
import { ConfirmAlert } from '../../../../../helpers/ui/alert'

import { cancelToken } from "../../../../../services/adapters/kepegawaian/dukService"

import DataTableBloc from '../Blocs/DataTableBloc'
import apiResponse from '../../../../../services/apiResponse'

import moment from "moment"

class TableActiveComponent extends Component {
    dataTableBloc = new DataTableBloc();

    source
    historyTable = 'historyIPTableActive'
    defaultOrder = 'ip_employee_name'
    defaultSize = 10
    defaultSort = 'asc'
    configDatatable = {
        ...config('datatable'),
        sort: {
            column: this.defaultOrder,
            order: this.defaultSort
        }
    }

    constructor(props) {
        super(props)
        this.state = {
            tooltip: false,
            detailUuid: null,
            formUuid: null,
            updateUuid: null,
            inactiveUuid: null,
            defaultSize: 10,
            rows: [],
            totalRow: 0,
            loadingTable: true,
            filter: sessionStorage.getItem(this.historyTable) ?
                JSON.parse(sessionStorage.getItem(this.historyTable)) :
                {
                    filter_value: "",
                    page_number: 1,
                    page_size: this.defaultSize,
                    sort_order: {
                        column: this.defaultOrder,
                        order: this.defaultSort
                    }
                }
        }
    }
    toggleTooltip = () => this.setState({ tooltip: !this.state.tooltip });

    loadData = async () => {
        /* history Datatable */
        sessionStorage.setItem(this.historyTable, JSON.stringify(this.state.filter))

        let additionalFilter = this.props.additionalFilter;

        /* kirim ke server */
        let offset = (this.state.filter.page_number-1)*this.state.filter.page_size
        if(this.state.defaultSize!==this.state.filter.page_size) {
            this.setState({
                defaultSize: this.state.filter.page_size
            })
            offset = 0
            this.configDatatable.page_number = 1
        }
        const query = {
            search: this.state.filter.filter_value,
            limit: this.state.filter.page_size,
            offset: offset,
            order: this.state.filter.sort_order.column,
            sort: this.state.filter.sort_order.order,
            status: 1,
            ...additionalFilter,
            is_employee : 1
        }
        await this.dataTableBloc.fetchRowTable(query, this.source.token)
    }

    setTokenAPI = () => {
        if (typeof this.source != typeof undefined) {
            this.source.cancel();
        }
        this.source = cancelToken()
        this.loadData()
    }

    confirmResponse = (response) => {
        let forState = {}
        switch(response) {
            case 'cancel':
                forState = {
                    confirm: false
                }
                break;
            case 'confirm':
                forState = {
                    loading: true,
                    confirm: false
                }
                this.inactiveData()
                break;
            case 'success':
                forState = {
                    success: false,
                    redirect: true
                }
                break;
             case 'failed':
                forState = {
                    failed: false
                }
                break;
            default:       
        }
        this.setState(forState)
    }
    
    inactiveData = async () => {
        await this.dataTableBloc.fetchInactive({ uuid: this.state.inactiveUuid })
    }

    componentDidMount() {
        this.setTokenAPI()

        this.dataTableBloc.rowtableChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.INITIAL:
                    this.setState({
                        loadingTable: false
                    })
                    break
                case apiResponse.LOADING:
                    this.setState({
                        loadingTable: true
                    })
                    break
                case apiResponse.COMPLETED:
                    const response = result.data.response
                    this.setState({
                        totalRow: response.total,
                        rows: response.result,
                        loadingTable: false
                    })
                    break
                case apiResponse.ERROR:
                    
                    break
                default:
                    break
            }
        })
    }

    componentWillUnmount() {
        this.dataTableBloc.rowtableChannel.unsubscribe()
    }

    columns = [
        {
            key: "ip_employee_nip",
            text: "NIP",
            className: "ip_employee_nip",
            sortable: true,
            width: '80'
        },
        {
            key: "ip_employee_name",
            text: "Nama",
            className: "ip_employee_name",
            sortable: true,
            width: '20%'
        },
        {
            key: "ip_qualification_score",
            text: "Kualifikasi",
            className: "ip_qualification_score",
            sortable: true,
            cell: record => {
                return record.ip_qualification_score;
            }
        },
        {
            key: "ip_competition_score",
            text: "Kompetensi",
            className: "ip_competition_score",
            sortable: true,
            cell: record => {
                return record.ip_competition_score;
            }
        },
        {
            key: "ip_performance_score",
            text: "Kinerja",
            className: "ip_performance_score",
            sortable: true,
            cell: record => {
                return record.ip_performance_score;
            }
        },
        {
            key: "ip_discipline_score",
            text: "Disiplin",
            className: "ip_discipline_score",
            sortable: true,
        },
        {
            key: "ip_score",
            text: "Nilai IP",
            className: "ip_score text-center",
            sortable: true,
            cell: record => {
                //return (`${} <br/> (${record.ip_score_name})`);
                return (
                    <>
                        <strong>( {record.ip_score} )</strong> <br />
                        <span>{record.ip_score_name}</span>
                    </>
                );
            }
        },
        // {
        //     key: "employee_create_date",
        //     text: "Tanggal",
        //     className: "rating",
        //     sortable: true,
        //     cell: record => {
        //         return moment(record.employee_create_date).format('DD/MM/YYYY');
        //     }
        // },
        {
            key: "action",
            text: "Action",
            className: "action",
            width: 120,
            sortable: false,
            align: 'center',
            cell: record => {
                const thisId = record.ip_id
                return (
                    <Fragment>
                        <span>
                            <button
                                className="btn btn-primary btn-sm"
                                id={`detail-${thisId}`}
                                onClick={() => {
                                    this.setState({
                                        detailUuid: record.ip_uuid
                                    })

                                    // set current employee uuid selected
                                    // let dataUser = {
                                    //     employee_uuid: record.employee_uuid
                                    // }
                                    // localStorage.setItem('employeeSelected', JSON.stringify(dataUser))
                                }}
                                style={{
                                    marginRight: '2px',
                                    padding: '2px 5px'
                                }}>
                                    <i className="uil-file-search-alt"></i>
                            </button>
                            <Tooltip
                                style={{
                                    marginBottom: 2
                                }}
                                placement="top" isOpen={this.state[`detail${thisId}`]} target={"detail-" + thisId}
                                toggle={() => {
                                    this.setState({
                                        [`detail${thisId}`] : !this.state[`detail${thisId}`]
                                    })
                                }}
                            >Lihat Detail IP</Tooltip>
                        </span>

                        <span>
                            <button
                                className="btn btn-success btn-sm"
                                id={`form-${thisId}`}
                                onClick={() => {
                                    this.setState({
                                        formUuid: record.ip_uuid
                                    })

                                    // set current employee uuid selected
                                    // let dataUser = {
                                    //     employee_uuid: record.employee_uuid
                                    // }
                                    // localStorage.setItem('employeeSelected', JSON.stringify(dataUser))
                                }}
                                style={{
                                    marginRight: '2px',
                                    padding: '2px 5px'
                                }}>
                                    <i className="uil-clipboard-alt"></i>
                            </button>
                            <Tooltip
                                style={{
                                    marginBottom: 2
                                }}
                                placement="top" isOpen={this.state[`form${thisId}`]} target={"form-" + thisId}
                                toggle={() => {
                                    this.setState({
                                        [`form${thisId}`] : !this.state[`form${thisId}`]
                                    })
                                }}
                            >Lihat Formulir IP</Tooltip>
                        </span>
                    </Fragment>
                );
            }
        }
    ]

    render() {
        return (
            <>
                <MKIDatatable
                    className={this.configDatatable.tableClass}
                    config={this.configDatatable}
                    records={this.state.rows}
                    columns={this.columns}
                    dynamic={true}
                    minWidth={1000}
                    total_record={this.state.totalRow}
                    initial={this.state.filter}
                    onChange={(filter) => {
                        this.setState({
                            loadingTable: true,
                            filter: filter
                        }, function () {
                            this.setTokenAPI()
                        });
                    }}
                    loading={this.state.loadingTable}
                />
                <ConfirmAlert
                    confirmTitle="Konfirmasi!"
                    confirmInfo="Apakah anda yakin akan menghapus data ini?"

                    loadingTitle="Mengirim data..."
                    loadingInfo="Tunggu beberapa saat"

                    successTitle="Berhasil!"
                    successInfo="Data berhasil dihapus"

                    failedTitle="Gagal!"
                    failedInfo="Data gagal dihapus"

                    showConfirm={this.state.confirm}
                    showLoading={this.state.loading}
                    showSuccess={this.state.success}
                    showFailed={this.state.failed}

                    response={this.confirmResponse}
                />
                { this.state.detailUuid !== null ?
                    <Redirect to={"/kepegawaian/indeks_professionalitas.html?detail&uuid="+this.state.detailUuid}/>
                : null }
                { this.state.formUuid !== null ?
                    <Redirect to={"/kepegawaian/indeks_professionalitas.html?form&uuid="+this.state.formUuid}/>
                : null }
                {/* { this.state.updateUuid !== null ?
                    <Redirect to={"/kepegawaian/home.html?update&uuid=" + this.state.updateUuid}/>
                : null } */}
            </>
        )
    }

}

export default TableActiveComponent